import { render, staticRenderFns } from "./useBalance.vue?vue&type=template&id=a4288a18&scoped=true&"
import script from "./useBalance.vue?vue&type=script&lang=js&"
export * from "./useBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4288a18",
  null
  
)

export default component.exports